import * as THREE from 'three';

const OPTIMIZATION_CONFIG = {
    mobile: {
        enabled: /Mobi|Android/i.test(navigator.userAgent),
        scale: 0.35,              
        disableNormals: true,     
        disableRoughness: false,  
        disableEmissive: false,   
        generateMipmaps: false,   
        minFilter: THREE.LinearFilter
    },
    desktop: {
        enabled: false,           
        scale: 1.0,
        disableNormals: false,
        generateMipmaps: true,
        minFilter: THREE.LinearMipmapLinearFilter
    }
};

export class TextureOptimizer {
    static get config() {
        return OPTIMIZATION_CONFIG.mobile.enabled ? OPTIMIZATION_CONFIG.mobile : OPTIMIZATION_CONFIG.desktop;
    }

    static async optimizeMesh(obj) {
        const cfg = this.config;
        if (!cfg.enabled && cfg.scale === 1.0) return;

        if (obj.material) {
            const materials = Array.isArray(obj.material) ? obj.material : [obj.material];
            
            for (const mat of materials) {
                this._processMap(mat, 'map', cfg.scale);
                
                if (cfg.disableNormals) { 
                    if(mat.normalMap) mat.normalMap.dispose();
                    mat.normalMap = null; 
                } else {
                    this._processMap(mat, 'normalMap', cfg.scale);
                }

                if (cfg.disableRoughness) {
                    if(mat.roughnessMap) mat.roughnessMap.dispose();
                    mat.roughnessMap = null;
                } else {
                    this._processMap(mat, 'roughnessMap', cfg.scale);
                }

                if (cfg.disableEmissive) {
                    if(mat.emissiveMap) mat.emissiveMap.dispose();
                    mat.emissiveMap = null;
                } else {
                    this._processMap(mat, 'emissiveMap', cfg.scale);
                }

                mat.needsUpdate = true;
            }
        }
    }

    static _processMap(material, mapType, scale) {
        const tex = material[mapType];
        if (!tex || !tex.isTexture || tex.userData.optimized) return;

        const img = tex.image;
        if (img && img.width > 0) {
            const canvas = document.createElement('canvas');
            canvas.width = Math.floor(img.width * scale);
            canvas.height = Math.floor(img.height * scale);
            
            const ctx = canvas.getContext('2d');
            
            // ВАЖНО: Рисуем текстуру без изменений ориентации на канвасе
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            const newTex = new THREE.CanvasTexture(canvas);
            
            // ИСПРАВЛЕНИЕ СМЕЩЕНИЙ И ПЕРЕВОРОТОВ:
            newTex.flipY = tex.flipY; // Копируем состояние переворота из оригинала
            newTex.colorSpace = tex.colorSpace;
            newTex.wrapS = tex.wrapS;
            newTex.wrapT = tex.wrapT;
            newTex.repeat.copy(tex.repeat);
            newTex.offset.copy(tex.offset);
            newTex.center.copy(tex.center);
            newTex.rotation = tex.rotation;

            // Сохраняем фильтрацию (чтобы не было "мыла" там, где не нужно)
            newTex.magFilter = tex.magFilter;
            newTex.anisotropy = tex.anisotropy;
            
            // Применяем настройки мип-маппинга из конфига
            newTex.generateMipmaps = this.config.generateMipmaps;
            newTex.minFilter = this.config.generateMipmaps ? tex.minFilter : this.config.minFilter;
            
            newTex.userData.optimized = true;

            material[mapType] = newTex;
            
            // Освобождаем память
            tex.dispose();
        }
    }
}